import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { syncfusionDialogUtilityService } from 'subjects/SyncfusionDialogUtilityHelperService';

const SyncfusionDialogUtilityHelper = () => {
    const location = useLocation();

    useEffect(() => syncfusionDialogUtilityService.configureDialogUtility(), []);

    useEffect(() => syncfusionDialogUtilityService.closeDialog(), [location.pathname]);

    return null;
};

export default SyncfusionDialogUtilityHelper;
